import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, FileText, Package, Receipt, Mail, Send, BarChart3, Layers, LogOut, ArrowLeft, Command, UploadCloud, MessageCircleQuestion } from "lucide-react";

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const nav = [
    { to: "/admin", label: "Overview", icon: LayoutDashboard, exact: true },
    { to: "/admin/documents", label: "Documents", icon: FileText },
    { to: "/admin/master-import", label: "Master Import", icon: UploadCloud },
    { to: "/admin/systems", label: "Systems", icon: Layers },
    { to: "/admin/products", label: "Products", icon: Package },
    { to: "/admin/orders", label: "Orders", icon: Receipt },
    { to: "/admin/leads", label: "Leads", icon: Mail },
    { to: "/admin/emails", label: "Emails", icon: Send },
    { to: "/admin/insights", label: "Insights", icon: BarChart3 },
    { to: "/admin/feedback", label: "Feedback", icon: MessageCircleQuestion },
  ];
  const isActive = (n) => (n.exact ? pathname === n.to : pathname.startsWith(n.to));

  return (
    <div className="min-h-screen flex">
      <aside className="w-64 bg-[#0A0A0A] text-white hidden md:flex flex-col">
        <div className="h-16 flex items-center px-6 border-b border-white/10">
          <Link to="/" className="flex items-center gap-2.5">
            <div className="w-8 h-8 bg-primary flex items-center justify-center">
              <span className="font-heading font-black text-white">C</span>
            </div>
            <span className="font-heading font-bold tracking-tight">Admin</span>
          </Link>
        </div>
        <nav className="flex-1 p-4 space-y-1">
          {nav.map((n) => {
            const Icon = n.icon;
            return (
              <Link key={n.to} to={n.to} data-testid={`admin-nav-${n.label.toLowerCase()}`}
                className={`flex items-center gap-3 px-4 py-2.5 text-sm font-medium transition-colors ${
                  isActive(n) ? "bg-primary text-white" : "text-white/70 hover:bg-white/5"
                }`}>
                <Icon className="w-4 h-4" /> {n.label}
              </Link>
            );
          })}
        </nav>
        <div className="p-4 border-t border-white/10 space-y-1">
          <Link to="/ops" data-testid="admin-nav-ops" className="flex items-center gap-3 px-4 py-2.5 text-sm font-semibold bg-indigo-600 text-white hover:bg-indigo-500">
            <Command className="w-4 h-4" /> Ops Platform
          </Link>
          <Link to="/" className="flex items-center gap-3 px-4 py-2.5 text-sm text-white/60 hover:bg-white/5">
            <ArrowLeft className="w-4 h-4" /> View site
          </Link>
          <button onClick={() => { logout(); navigate("/"); }} data-testid="admin-logout"
            className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-accent hover:bg-white/5">
            <LogOut className="w-4 h-4" /> Log out
          </button>
        </div>
      </aside>

      <div className="flex-1 bg-secondary/40 min-w-0">
        <header className="h-16 bg-white border-b border-border flex items-center justify-between px-6">
          <div className="font-heading font-semibold">Centennial Admin</div>
          <div className="text-sm text-muted-foreground">{user?.email}</div>
        </header>
        <main className="p-6 lg:p-10">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
